import * as Popover from '@radix-ui/react-popover';
import {
  MOON_800,
  MOON_850,
  TEAL_550,
  WHITE,
} from '@wandb/weave/common/css/globals.styles';
import {Button} from '@wandb/weave/components/Button';
import React, {ReactNode, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {redirectToSignupThenBackHere} from '../util/auth';
import {login} from '../util/urls';

const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 32px 32px;

  width: 348px;
  height: 208px;

  background: ${WHITE};

  box-shadow: 0px 8px 24px rgba(24, 27, 31, 0.2);
  border-radius: 8px;

  z-index: 1000;
`;

const StyledButton = styled(Button)`
  :focus {
    outline: none;
  }
`;

const Title = styled.span`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;

  color: ${MOON_850};
`;

const Subtitle = styled(Title)`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  color: ${MOON_800};

  margin-bottom: 24px;
  margin-top: 4px;
`;

const Links = styled.a`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  color: ${MOON_800};
  text-decoration-line: underline;
  :hover {
    color: ${TEAL_550};
    text-decoration-line: underline;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const LoginPopup = ({
  isLoggedIn = true,
  children,
  onClose,
  ...props
}: {
  isLoggedIn?: boolean;
  onClose?: () => void;
  children: ReactNode;
} & Popover.PopoverContentTypeProps) => {
  const [isLoginOverlayOpen, setIsLoginOverlayOpen] = useState<boolean>(false);

  const closeModal = () => {
    setIsLoginOverlayOpen(false);
    onClose?.();
  };

  return (
    <Popover.Root
      open={isLoginOverlayOpen}
      onOpenChange={(b: boolean) => {
        if (!isLoggedIn) {
          setIsLoginOverlayOpen(b);
        }
      }}>
      <Popover.Trigger
        asChild
        onClick={() => {
          if (!isLoggedIn) {
            setIsLoginOverlayOpen(!isLoginOverlayOpen);
          }
        }}>
        {children}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content onOpenAutoFocus={() => {}} {...props}>
          <LoginWrapper>
            <Title>Join Weights & Biases</Title>
            <Subtitle>
              <Links href={login({signup: true})}>Sign up</Links> {' or '}
              <Links href={login()}>Log in</Links>
              {' to leave a comment, star reports, and much more.'}
            </Subtitle>
            <ButtonWrapper>
              <StyledButton
                size="large"
                onClick={() => redirectToSignupThenBackHere(true)}>
                Sign up
              </StyledButton>
              <StyledButton variant="ghost" size="large" onClick={closeModal}>
                Cancel
              </StyledButton>
            </ButtonWrapper>
          </LoginWrapper>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
